import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const GET_PAYMENT_LOADING = 'GET_PAYMENT_LOADING';
export const GET_PAYMENT_SUCCESS = 'GET_PAYMENT_SUCCESS';
export const GET_PAYMENT_REJECT = 'GET_PAYMENT_REJECT';

//* ACTIONS ------------------------------------------------
export const getPaymentLoading = () => ({ type: GET_PAYMENT_LOADING });
export const getPaymentSuccess = (payload) => ({ type: GET_PAYMENT_SUCCESS, payload });
export const getPaymentReject = (payload) => ({ type: GET_PAYMENT_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const getPaymentRequest = async (params = {}, getState) => {
    const options = await withToken({
        method: Methods.GET,
        params,
    }, getState);
    return request(`/api/TypePayments`, options);
};

